import { fetchAll } from './common'

export const CURRENCIES_URL = '/v2/data/currencies'

export const fetchCurrencies = async (): Promise<ICurrency[]> =>
  fetchAll<ICurrency>(CURRENCIES_URL, { per_page: 150 })
